/**
 * "You were signed out." The request layer (services/BaseService) sets this when the server, or a missing token, says the
 * admin is no longer signed in; the sign-in page reads it once and shows one plain line. A normal Sign out never sets it.
 *
 * Kept in sessionStorage (survives the redirect and a reload) with an in-memory copy for the browsers that block storage.
 */
const KEY = "admin-signed-out-notice";

export const SIGNED_OUT_MESSAGE = "You were signed out. Please sign in again.";

let inMemory = false;

export function markSignedOut(): void {
  inMemory = true;
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    // storage blocked: the in-memory copy still covers the redirect inside this page load
  }
}

/** Is there a notice waiting? Does not clear it (React may render twice). */
export function hasSignedOutNotice(): boolean {
  if (inMemory) return true;
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function clearSignedOutNotice(): void {
  inMemory = false;
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
